<!--
 * @ Author: Clark
 * @ Create Time: 2023-02-05 20:20:57
 * @ Modified by: Your name
 * @ Modified time: 2023-02-14 11:50:50
 * @ Description: 营销管理>标签分组>用户分组>用户分组详情
 -->

<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div class="content">
      <ykc-detail-plus class="box-card" :labelWidth="140">
        <div slot="header" class="clearfix">
          <span>对账单信息</span>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="结算单号">
            <span>{{ dealData(formData.settleNo) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="结算时间">
            <span>{{ dealData(formData.setSettleDate) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="结算方式">
            <span>{{ dealData(formData.settleWay) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="站点编码">
            <span>{{ dealData(formData.stationCode) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="站点名称">
            <span>{{ dealData(formData.stationName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="经营模式">
            <span>
              {{
                dealData(
                  formData.tradeMode === 1 ? '自营' : formData.tradeMode === 2 ? '加盟商' : '-'
                )
              }}
            </span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="商户">
            <span>{{ dealData(formData.operatorName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="取电方式">
            <span>{{ dealData(formData.eleWay) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="">
            <span></span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="总电量">
            <span>{{ dealData(formData.settleTotalEleCap) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="电费">
            <span>{{ dealData(formData.settleTotalPowerFee) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="服务费平台分成">
            <span>{{ dealData(formData.serviceWayFeeStr) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="服务费平台分成金额">
            <span>{{ dealData(formData.serviceFeeSharingAmount) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="用户实付金额">
            <span>{{ dealData(formData.userActualIncome) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="结算总金额">
            <span>{{ dealData(formData.settleTotalAmount) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus :label="formData.status === 1 ? '申请备注' : ''">
            <span v-if="formData.status === 1">{{ dealData(formData.remark) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="审批状态">
            <span>{{ dealData(formData.statusName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus :label="formData.status !== 1 ? '审批备注' : ''">
            <span v-if="formData.status !== 1">{{ dealData(formData.auditRemark) }}</span>
          </ykc-detail-item-plus>
        </div>
        <div class="flexBox">
          <ykc-detail-item-plus label="发票状态">
            <span>{{ dealData(formData.invoiceStatusName) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="收款日期">
            <span>{{ dealData(formData.collectionDate) }}</span>
          </ykc-detail-item-plus>
          <ykc-detail-item-plus label="">
            <span></span>
          </ykc-detail-item-plus>
        </div>
      </ykc-detail-plus>

      <ykc-detail-plus class="box-card" :labelWidth="110">
        <div slot="header" class="clearfix">
          <span>结算信息</span>
        </div>

        <ykc-table
          ref="YkcTable"
          style="box-shadow: none"
          operateFixedType="right"
          :data="tableData"
          :columns="tableColumns"></ykc-table>
        <!-- :operateButtons="tableOperateButtons.filter(item => item.enabled())" -->
      </ykc-detail-plus>
    </div>
  </scroll-layout>
</template>

<script>
  import { franchiseeSettleManage } from '@/service/apis';

  export default {
    name: 'FranchiseementDetail',
    components: {},

    data() {
      return {
        id: '',
        formData: {},
        meterStatDTO: null,
        pageButtons: [
          {
            id: '0',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        tableData: [],
        tableColumns: [
          {
            label: '年月',
            prop: 'yearMonth',
            minWidth: '100px',
          },
          { label: '电量', prop: 'eleCap', minWidth: '100px' },
          { label: '电费金额', prop: 'eleFee', minWidth: '100px' },
          { label: '服务费平台分成金额', prop: 'serviceFeeSharingAmount', minWidth: '100px' },
          { label: '实付金额', prop: 'userActualIncome', minWidth: '100px' },
          { label: '结算金额', prop: 'totalAmount', minWidth: '100px' },
        ],
      };
    },
    computed: {},
    created() {
      const { id } = this.$route.query;
      this.id = id;
      this.queryDetail();
    },
    methods: {
      dealData(value) {
        return value === null ? '——' : value;
      },
      queryDetail() {
        // 编辑回显
        if (this.id) {
          franchiseeSettleManage
            .getOne({ id: this.id })
            .then(res => {
              this.formData = {
                ...res,
                auditRemark: res.auditRemark ?? res.audit_remark,
              };

              this.tableData = res.settleDetail || [];
            })
            .catch(() => {});
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .content {
    display: flex;
    flex: 1;
    flex-direction: column;
    .box-card {
      width: 100%;
      height: auto;
      border: none;
      margin: 10px 0px 0px 0px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      .pic-img {
        width: 60px;
        height: 60px;
        border-radius: 10px;
        cursor: pointer;
        margin-right: 20px;
      }
      .flexBox {
        display: flex;
        margin-bottom: 20px;
      }
      .status {
        margin-left: 10px;
        color: #fff;
        height: 20px;
        border-radius: 10px;
        min-width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
        line-height: 20px;
        &.stationStatus {
          &.status1000135 {
            background-color: #009f09;
          }
          &.status1000136 {
            background-color: #e81b1b;
          }
        }
        &.infoStatus {
          &.status1 {
            background-color: #009f09;
          }
          &.status2 {
            background-color: #ccc;
            color: #fff;
          }
          &.status0 {
            background-color: #e81b1b;
          }
        }
      }
      .title {
      }
    }
  }
</style>
